export const logError = (string: string): void => {
  console.error(`Property explorer error`, '\n\n', string);
};
